function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "52.3302802%",
  y1: "48.2232073%",
  x2: "101.999998%",
  y2: "100.999999%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#21232E",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#725DFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "15.7866379%",
  y1: "16.5654389%",
  x2: "101.999998%",
  y2: "100.999999%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#21232E",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#313445",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "52.3302802%",
  y1: "48.2232073%",
  x2: "101.999998%",
  y2: "100.999999%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#21232E",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C3672",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "hero",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-3-Copy",
  fill: "url(#linearGradient-1)",
  transform: "translate(508.500000, 353.000000) scale(-1, 1) translate(-508.500000, -353.000000) ",
  cx: 508.5,
  cy: 353,
  rx: 183.5,
  ry: 184
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-3",
  fill: "url(#linearGradient-2)",
  cx: 183.5,
  cy: 187,
  rx: 183.5,
  ry: 184
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-3-Copy",
  fill: "url(#linearGradient-3)",
  opacity: 0.486886161,
  transform: "translate(508.500000, 353.000000) scale(-1, 1) translate(-508.500000, -353.000000) ",
  cx: 508.5,
  cy: 353,
  rx: 183.5,
  ry: 184
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-4",
  stroke: "#FFFFFF",
  cx: 442.5,
  cy: 200.5,
  r: 200.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-5",
  fill: "#FFFFFF",
  cx: 308.5,
  cy: 54.5,
  r: 7.5
})));

var SvgHero = function SvgHero(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "694px",
    height: "539px",
    viewBox: "0 0 694 539",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHero, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero.8100dfd5.svg";
export { ForwardRef as ReactComponent };